import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useSelector } from 'react-redux';
import { getMerchCardsToShow } from '../../../constants/merchCards/MerchCardsToShow';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useTierQueryParam } from '../../../hooks/useTierQueryParam';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { getTBSuiteProductForProductLevelSelector } from '../../../selectors/ProductsSelectors';
import { BaseCardBadge } from '../../../v2/components/merch-card/BaseCardBadge';
import { SCREENS } from '../../../v2/constants/tracking/Screens';
import { SUITE_CARD } from '../../../v2/constants/tracking/TrackingSources';
import { useBadges } from '../../../v2/hooks/badges/useBadges';
import { useIsUngatedForPublicRemoveTabs } from '../../../v2/hooks/gating/useIsUngated';
import { isValidApiName } from '../../../v2/utils/typeguards';
import PricingPlanToggleButton from '../../buttons/PricingPlanToggleButton';
import { FreeCard } from '../cards/FreeCard';
import { StandardSuiteCard } from '../cards/suite/StandardSuiteCard';

// This is used as the merch cards for the customer platform routes
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SuitePageCardContainer = ({
  selectedTab
}) => {
  const isAppReady = useGlobalLoading();
  const isAppAuth = useSelector(isAppAuthSelector);
  const isUngatedForPublicRemoveTabs = useIsUngatedForPublicRemoveTabs();
  const tier = useTierQueryParam();
  const productLevelsToShow = getMerchCardsToShow({
    tab: selectedTab,
    tier,
    isUngatedForPublicRemoveTabs: !isAppAuth && isUngatedForPublicRemoveTabs
  });
  const productsToShow = useAppSelector(state => {
    if (!isAppReady) return [];
    const products = productLevelsToShow.map(productLevel => {
      if (productLevel === 'FREE') return FreeProducts.HUBSPOT_FREE;
      const product = getTBSuiteProductForProductLevelSelector(state, {
        suiteProductLevel: productLevel
      });
      if (product !== null && product !== void 0 && product.apiName) return product.apiName;
      return null;
    });
    return products.filter(isValidApiName);
  });
  const {
    badges,
    hasBadgeOnFirstColumn,
    hasBadgeOnLastColumn
  } = useBadges({
    productApiNames: productsToShow
  });
  const suiteCardComponents = productLevelsToShow.map((productLevel, index) => {
    var _badges$productsToSho;
    if (productLevel === 'FREE') {
      return /*#__PURE__*/_jsx(FreeCard, {
        productLine: "crm",
        columnStart: index + 1,
        trackingSource: SUITE_CARD
      }, productLevel);
    }
    return /*#__PURE__*/_jsx(StandardSuiteCard, {
      productLevel: productLevel,
      screen: SCREENS.SUITE,
      columnStart: index + 1,
      Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
        apiName: productsToShow[index],
        badgeName: badges === null || badges === void 0 || (_badges$productsToSho = badges[productsToShow[index]]) === null || _badges$productsToSho === void 0 ? void 0 : _badges$productsToSho.badgeName
      })
    }, productLevel);
  });
  const columns = productLevelsToShow.length;
  return /*#__PURE__*/_jsxs(PageSection, {
    hideOverflow: false,
    children: [/*#__PURE__*/_jsx(MerchCardColumns, {
      columns: columns,
      hasBadgeOnFirstColumn: hasBadgeOnFirstColumn,
      hasBadgeOnLastColumn: hasBadgeOnLastColumn,
      children: suiteCardComponents
    }), !isAppAuth && isUngatedForPublicRemoveTabs && /*#__PURE__*/_jsx(PricingPlanToggleButton, {
      tier: tier
    })]
  });
};